import Parameters from '@/assets/js/parameters'
const parameters = new Parameters()
import * as XLSX from 'xlsx';
class Shift {

    constructor(apiService = null) {
        this.obj_name = 'shift';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 送出前檢查表單填寫格式
    checkFromModel(formData) {
        const validations = [
            { condition: formData.form_name === '', message: '請輸入表單名稱' },
            { condition: formData.species_json.length <= 0, message: '請添加物種' },
            { condition: formData.form_json.length <= 0, message: '請輸入評估項目' },
        ];
        
        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }
    getDataAndWithHeaders(formList){
        let headers = [
            '*工號','姓名','*日期(YYYY/MM/DD)','*狀態代碼','班次代碼',
            '上班時間(HH:mm)','下班時間(HH:mm)',
            '休息時間(hh:mm~hh:mm；如有多組以","分隔；最多3組)',
            '全天支援單位代碼',
            '(1)支援單位代碼','(1)支援起時-hh:mm','(1)支援迄時-hh:mm',
            '(2)支援單位代碼','(2)支援起時-hh:mm','(2)支援迄時-hh:mm',
            '(3)支援單位代碼','(3)支援起時-hh:mm','(3)支援迄時-hh:mm',
        ];
        
        let data = [];
        for (let index = 0; index < formList.length; index++) {
            const form = formList[index];
            const departments = '' //所屬單位
            const schedule_date = this.apiService.shared.formatIosDate(form.schedule_date).replace(/-/g, '/')
            const scheduleType = parameters.scheduleTypes.find(item=>item.id===form.work_type)
            const scheduleClass = parameters.scheduleClassList.find(item=>item.id===form.shift_type)
            data.push([
                form.account_sn, //*工號
                form.account_name, //姓名
                schedule_date, //*日期(YYYY/MM/DD)
                scheduleType ? scheduleType.scheduleTypeCode : 'N/A', //*狀態代碼
                scheduleClass ? scheduleClass.scheduleClassCode : '', //班次代碼
                scheduleClass ? scheduleClass.start_work_time : '', //上班時間(HH:mm)
                scheduleClass ? scheduleClass.off_work_time : '', //下班時間(HH:mm)
                //scheduleClass ? scheduleClass.time : 0,
                '', //休息時間(hh:mm~hh:mm；如有多組以","分隔；最多3組)
                '', //全天支援單位代碼
                '','','', //(1)支援單位代碼','(1)支援起時-hh:mm','(1)支援迄時-hh:mm
                '','','', //(2)支援單位代碼','(2)支援起時-hh:mm','(2)支援迄時-hh:mm
                '','','' //(3)支援單位代碼','(3)支援起時-hh:mm','(3)支援迄時-hh:mm
            ])
        }
        return [headers, ...data];
    }

    async exportExcel(data,file_name) {
        console.log(`exportExcel=`, data);
        const dataWithHeaders = this.getDataAndWithHeaders(data);
        console.log(`dataWithHeaders:`, dataWithHeaders);
        // 生成工作表和工作簿
        const worksheet = XLSX.utils.aoa_to_sheet(dataWithHeaders); // aoa 表示數組數組結構
        // 設定自動寬度
        const colWidths = dataWithHeaders[0].map((_, colIndex) =>
            Math.max(
                ...dataWithHeaders.map(row => (row[colIndex] ? row[colIndex].toString().length : 0))
            )
        );
        worksheet['!cols'] = colWidths.map(width => ({ wch: width + 6 })); // wch: 寬度，+2 是增加緩衝
        // 設定凍結標題列和病歷編號欄
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        // 下載檔案
        XLSX.writeFile(workbook, `${file_name}.xlsx`);
    }

    // API 方法
    //班表 | 101新增更新班表
    async addOrUpdOrDelShiftScheduleByJson(parameter , progressEvent = null) {
        return this.callApi('post', 'addOrUpdOrDelShiftScheduleByJson', parameter , progressEvent);
    }
    //野放評估 | 102取得野放評估詳細資料
    async getShiftScheduleByYearMonth(parameter) {
        return this.callApi('get', 'getShiftScheduleByYearMonth', parameter);
    }
    //班表 | 103取得日期班表
    async getShiftScheduleByDate(parameter) {
        return this.callApi('get', 'getShiftScheduleByDate', parameter);
    }
}
export default Shift;